import startCase from "lodash/startCase";
import { JSX, PureComponent } from "react";

import { isEqual } from "lodash";

import SortDetails from "@app/projects/network-assessment/sortDetails";
import { SortDirection } from "@app/shared/griddle/enumerators";
import { Waffles, wafflesKeyColumnName } from "@app/shared/waffles";
import LoadingSpinner from "../LoadingSpinner";
import { OverallRecord } from "./overallRecord";

interface OverviewProps {
  records: OverallRecord[];
}

interface OverviewState {
  sortDetails: SortDetails<OverallRecord>;
  sortedRecords: OverallRecord[];
}

interface OverallWaffle {
  key: string;
  [x: string]: JSX.Element | string;
}

class Overall extends PureComponent<OverviewProps, OverviewState> {
  constructor(props: OverviewProps) {
    super(props);
    this.state = {
      sortDetails: {
        sortDirection: SortDirection.None,
        sortedColumn: null,
        subColumnKey: null,
      },
      sortedRecords: props.records,
    };
  }

  public componentDidUpdate(prevProps: OverviewProps) {
    if (!isEqual(prevProps.records, this.props.records)) {
      this.setState({
        sortedRecords: this.props.records,
      });
    }
  }

  public render() {
    if (!this.state.sortedRecords) {
      return <LoadingSpinner />;
    }
    return this.state.sortedRecords.map((r, i) => (
      <div key={r.networkType} className={i > 0 ? "mt15" : ""}>
        {this.renderRecord(r)}
      </div>
    ));
  }

  private renderRecord(record: OverallRecord) {

    return (
      <div className="row">
        <div className="col-sm-5">
          <Waffles<OverallWaffle>
            data={this.buildRecords(record)}
            testId="overall"
          />
        </div>
      </div>
    );
  }

  private buildRecords = (record: OverallRecord) => {
    return [
      {
        [wafflesKeyColumnName]: "k",
        [startCase(record.networkType)]: (
          <>
            <span className="text-primary d-block">{record.uniqueProviders.toLocaleString()} unique providers at {record.uniqueLocations.toLocaleString()} unique locations</span>
            ({record.accessPoints.toLocaleString()} total access points)
          </>
        ),
      },
    ];
  }
}

export { Overall };
